import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Palavra() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/devotionals/public").then((r) => setList(r.data)); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <div className="label">Palavra</div>
      <h1 className="font-display text-4xl sm:text-6xl font-black mt-2">Momentos com Deus.</h1>
      <p className="text-slate-400 mt-3 max-w-xl">Devocionais e versículos para alimentar a caminhada.</p>

      {list.length === 0 ? (
        <div className="ci-card p-12 mt-10 text-center text-slate-400">Em breve, novas palavras.</div>
      ) : (
        <div className="grid gap-5 md:grid-cols-2 mt-10">
          {list.map((d) => (
            <article key={d.id} className="ci-card p-6 sm:p-7">
              <div className="label">{d.reference}</div>
              <blockquote className="mt-3 font-display text-xl leading-snug text-white">"{d.verse}"</blockquote>
              <p className="mt-4 text-sm text-slate-300 leading-relaxed whitespace-pre-wrap">{d.text}</p>
              <div className="mt-5 text-xs text-slate-500">{new Date(d.date).toLocaleDateString("pt-BR")}</div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
